import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { ThemeProvider } from './contexts/ThemeContext';
import './styles.css';
import './styles/themes.css';
import axios from 'axios';

// Configure axios to include credentials with all requests
axios.defaults.withCredentials = true;

// Add response interceptor to handle authentication errors
axios.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 401) {
      // Only redirect to login if we're not already on the login page
      const currentPath = window.location.pathname;
      if (currentPath !== '/login' && currentPath !== '/') {
        // Clear local storage
        localStorage.removeItem('isAuthenticated');
        localStorage.removeItem('user');
        // Redirect to login
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

ReactDOM.render(
  <ThemeProvider>
    <App />
  </ThemeProvider>, 
  document.getElementById('root')
);
